import { makeStyles } from 'tss-react/mui';

export default makeStyles({ name: 'Pagination' })({
    container: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        flexWrap: 'wrap',
        width: '100%',
        gap: 12
    },
    rowsPerPageContainer: {
        display: 'flex',
        alignItems: 'center',
        gap: 12
    },
    rowsPerPageLabel: {
        fontWeight: 500,
        fontSize: 14,
        lineHeight: '140%',
        color: '#38383A'
    },
    pagination: {
        '& ul': {
            display: 'flex',
            gap: 2
        }
    },
    paginationItem: {
        margin: 0,
        fontWeight: 500,
        fontSize: 14,
        lineHeight: '140%'
    },
    selected: {
        background: '#232323 !important',
        color: '#FFFFFF'
    },
    menu: {
        marginTop: 4
    },
    menuList: {
        padding: 8
    },
    menuItem: {
        fontWeight: 400,
        fontSize: 13,
        lineHeight: '16px',
        color: '#38383A',
        padding: '12px 24px 12px 16px',
        borderRadius: 8
    },
    menuItemSelected: {
        background: 'rgba(0, 0, 0, 0.12) !important'
    },
    rowsPerPageSelectRoot: {
        borderRadius: 8,
        fontWeight: 400,
        fontSize: 13,
        lineHeight: '140%',
        color: '#38383A',
        background: 'transparent',
        '& fieldset': {
            border: '1px solid rgba(0, 0, 0, 0.23) !important'
        }
    },
    rowsPerPageSelect: {
        '&:focus': {
            borderRadius: 8,
            backgroundColor: 'transparent'
        }
    },
    rowsPerPageSelectIcon: {
        transition: 'transform 0.2s'
    },
    paginationContainer: {
        display: 'flex',
        alignItems: 'center',
        gap: 8
    },
    paginationLabel: {
        fontWeight: 500,
        fontSize: 14,
        lineHeight: '140%',
        color: '#38383A'
    }
});
